import ApiService from "./apiservice";

export const MissionService = {
    PersonMissionList(payload) {
        return ApiService.get("Mission/PersonMissionList", payload);
    },
    AddMission(payload) {
        return ApiService.post("AddMission", payload);
    },
    AddMissionHour(payload) {
        return ApiService.post("AddMissionHour", payload);
    },
    GetWebMissionTypeList() {
        return ApiService.get("Mission/GetWebMissionTypeList");
    },
    GetAllMissionTypeList() {
        return ApiService.get("Mission/GetAllMissionTypeList");
    },
    GetCityList() {
        return ApiService.get("Mission/GetCityList");
    },
    GetMissionDetailForPerson(payload) {
        return ApiService.get("Mission/GetMissionDetailForPerson", payload);
    },
    GetMissionDetailForAdmin(payload) {
        return ApiService.get("mission/GetMissionDetailForAdmin", payload);
    },
    OprationOnMissionArchive(payload) {
        return ApiService.post("OprationOnMissionArchive", payload);
    },
    OprationOnMissionRequest(payload) {
        return ApiService.post("OprationOnMissionRequest", payload);
    },
    GetApproveDegree(payload) {
        return ApiService.get("Mission/GetApproveDegree", payload);
    },
    GetMissionListForAdmins(payload) {
        return ApiService.get("Mission/GetMissionListForAdmins", payload);
    },
    GetMissionHourForMission(params) {
        return ApiService.get("Mission/GetMissionHourForMission", params);
    },
    GetPeriodMissionDetail(params) {
        return ApiService.get("Mission/GetPeriodMissionDetail", params);
    },
    GetMissionPageNo(params) {
        return ApiService.get("GetMissionPageNo", params);
    },
};